import { QUERY_HANDBOOK } from '@/const/query'
import { refreshArr } from '@/utils/array/reactive'
import { showAlertError } from '@/utils/store/alert'

export function SET_STATE_LIST (state, { key, list }) {
  refreshArr(state[key], list)
}

const createMutations = () => ({
  SET_STATE_LIST
})

const createActions = () => ({
  async GETRequest ({ commit }, {
    api,
    method = 'getAll',
    keyStateList = 'list',
    query = {},
    search = null
  }) {
    try {
      const response = await api[method]({
        ...QUERY_HANDBOOK,
        'search[all]': search,
        ...query
      })

      commit('SET_STATE_LIST', {
        key: keyStateList,
        list: response.data?.data || []
      })
    } catch (e) {
      showAlertError(e)
    }
  }
})

export const vuexHandbook = {
  createMutations,
  createActions
}
